import { CustomButton } from '../../../../../components/CustomButton';
import RModal from '../../../../../components/Rsuite/Modal';
import { useCallback, useEffect, useState } from 'react';
import { Field } from '../../styles';
import { Label } from '../../../../../components/Label';
import { CustomInput } from '../../../../../components/CustomInput';
import api from '../../../../../services/api';
import { toastSuccess, toastError } from '../../../../../toasts';
import { CustomSelectPicker } from '../../../../../components/CustomSelectPicker';
import {
  schemaCriarBeneficio,
  schemaEditarBeneficio,
} from './schema/beneficio.schema';
import { promotionsBenefitTypes, promotionsTypes } from '../../../../../enums/promotionsTypes';

const listTipoDesconto = [
  { label: 'Desconto percentual', value: promotionsBenefitTypes.PERCENTUAL },
  { label: 'Desconto fixo', value: promotionsBenefitTypes.VALOR_FIXO },
  { label: 'Grátis', value: promotionsBenefitTypes.GRATIS },
];

const EditarCadastrarBeneficiosPromo = ({
  open,
  handleClose,
  benefit,
  products,
  promo,
  setBenefits,
}) => {
  const [productId, setProductId] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [tipoDesconto, setTipoDesconto] = useState('');
  const [valorDesconto, setValorDesconto] = useState(0);

  const isTamanho = promo?.Tipo === 'DESCONTO_TAMANHO';
  const endpoint = isTamanho ? 'promocao-beneficio-tamanho' : 'promocao-beneficio';

  const handleCreate = useCallback(async () => {
    const form = isTamanho
      ? {
          IdPromocao: promo.Id,
          IdTamanho: productId,
          DescricaoTamanho: products.find((p) => p.value === productId)?.label ?? '',
          TipoDesconto: tipoDesconto,
          ValorDesconto: valorDesconto,
        }
      : {
          IdPromocao: promo.Id,
          IdProduto: productId,
          Quantidade: quantity,
          TipoDesconto: tipoDesconto,
          ValorDesconto: valorDesconto,
        };

    const schema = isTamanho ? null : schemaCriarBeneficio;

    const doCreate = async (validated) => {
      await api
        .post(`${endpoint}/criar`, validated)
        .then((response) => {
          const newItem = isTamanho
            ? response.data
            : {
                ...response.data,
                DescricaoProduto: products.find(
                  (x) => x.value === response.data.IdProduto,
                )?.label,
              };
          setBenefits((state) => [...state, newItem]);
          toastSuccess('Benefício cadastrado com sucesso.');
          handleClose();
        })
        .catch((error) => console.log('Erro ao cadastrar benefício ' + error));
    };

    if (schema) {
      schema.validate(form).then(doCreate).catch((error) => toastError(error.message));
    } else {
      doCreate(form);
    }
  }, [
    handleClose,
    productId,
    products,
    promo?.Id,
    quantity,
    setBenefits,
    tipoDesconto,
    valorDesconto,
    isTamanho,
    endpoint,
  ]);

  const handleUpdate = useCallback(async () => {
    const form = isTamanho
      ? {
          IdTamanho: productId,
          DescricaoTamanho: products.find((p) => p.value === productId)?.label ?? '',
          TipoDesconto: tipoDesconto,
          ValorDesconto: valorDesconto,
        }
      : {
          IdProduto: productId,
          Quantidade: quantity,
          TipoDesconto: tipoDesconto,
          ValorDesconto: valorDesconto,
        };

    const doUpdate = async (validated) => {
      await api
        .patch(`${endpoint}/${benefit.Id}`, validated)
        .then((response) => {
          setBenefits((state) =>
            state.map((e) => (e.Id !== response.data.Id ? e : response.data)),
          );
          toastSuccess('Benefício alterado com sucesso.');
          handleClose();
        })
        .catch((error) => console.log('Erro ao atualizar benefício ' + error));
    };

    if (!isTamanho) {
      schemaEditarBeneficio.validate(form).then(doUpdate).catch((error) => toastError(error.message));
    } else {
      doUpdate(form);
    }
  }, [
    productId,
    quantity,
    tipoDesconto,
    valorDesconto,
    benefit?.Id,
    setBenefits,
    handleClose,
    isTamanho,
    endpoint,
    products,
  ]);

  useEffect(() => {
    if (benefit) {
      setProductId(benefit.IdProduto);
      setQuantity(benefit.Quantidade);
      setTipoDesconto(benefit.TipoDesconto);
      setValorDesconto(
        +benefit?.ValorDesconto > 0
          ? benefit.ValorDesconto
          : 0,
      );
    }
  }, [benefit, open]);

  return (
    <RModal
      open={open}
      onClose={handleClose}
      title={(benefit ? 'Editar' : 'Cadastrar') + ' benefício'}
      footer={
        <>
          <CustomButton appearance="default" onClick={handleClose}>
            Cancelar
          </CustomButton>
          <CustomButton onClick={benefit ? handleUpdate : handleCreate}>
            Salvar
          </CustomButton>
        </>
      }
    >
      <Field>
        <Label>
          {promo?.Tipo === promotionsTypes.BORDAS
            ? 'Borda'
            : promo?.Tipo === promotionsTypes.DESCONTO_TAMANHO
            ? 'Tamanho'
            : 'Produto'}
        </Label>
        <CustomSelectPicker
          data={products}
          style={{ width: 400 }}
          value={productId}
          onChange={setProductId}
        />
      </Field>
      <Field>
        <Label>Tipo de desconto</Label>
        <CustomSelectPicker
          searchable={false}
          data={listTipoDesconto.filter(item => {
            if (promo?.Tipo === promotionsTypes.DESCONTO_TAMANHO) {
              return item.value !== promotionsBenefitTypes.GRATIS;
            }
            return true;
          })}
          style={{ width: 400 }}
          value={tipoDesconto}
          onChange={setTipoDesconto}
        />
      </Field>
      {[
        promotionsBenefitTypes.VALOR_FIXO,
        promotionsBenefitTypes.PERCENTUAL
      ].includes(tipoDesconto) && (
        <Field>
          <Label>Valor</Label>
          <CustomInput
            type="number"
            min={1}
            value={valorDesconto}
            onChange={(e) => {
              if (e >= 0) setValorDesconto(e);
            }}
          />
        </Field>
      )}
      {promo.Tipo !== promotionsTypes.BORDAS && promo.Tipo !== promotionsTypes.DESCONTO_TAMANHO && (
        <Field>
          <Label>Quantidade</Label>
          <CustomInput
            type="number"
            min={1}
            value={quantity}
            onChange={(e) => {
              if (e > 0) setQuantity(+e);
            }}
          />
        </Field>
      )}
    </RModal>
  );
};

export default EditarCadastrarBeneficiosPromo;
